import { keyframes } from '@emotion/core';

export const slideInLeft = keyframes`
  0% {
    transform: translate3d(-101%, 0, 0);
  }
  100% {
    transform: translate3d(0, 0 , 0);
  }
`;

export const slideOutLeft = keyframes`
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(-101%, 0, 0);
  }
`;

export const slideInRight = keyframes`
  0% {
    transform: translate3d(101%, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
`;

export const slideOutRight = keyframes`
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(101%, 0, 0);
  }
`;

export const slideInTop = keyframes`
  0% {
    transform: translate3d(0, -101%, 0);
  }
  100% {
    transform: translate3d(0, 0 , 0);
  }
`;

export const slideOutTop = keyframes`
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, -101%, 0);
  }
`;

export const slideInBottom = keyframes`
  0% {
    transform: translate3d(0, 101%, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
`;

export const slideOutBottom = keyframes`
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, 101%, 0);
  }
`;

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

export const fadeOut = keyframes`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
